import StyledText, { Props } from './StyledText';

export default function Title({ ...props }: Props & React.PropsWithChildren) {
  return <StyledText $fontSize="xxxl" $fontWeight="bold" {...props} />;
}
